const RECEPTIONIST_ID_KEY = 'receptionist-current-id';

export function getCurrentReceptionistId() {
  const envId = process.env.REACT_APP_RECEPTIONIST_ID?.trim();
  return envId || sessionStorage.getItem(RECEPTIONIST_ID_KEY) || '';
}

export function setCurrentReceptionistId(id) {
  if (!id) {
    sessionStorage.removeItem(RECEPTIONIST_ID_KEY);
  } else {
    sessionStorage.setItem(RECEPTIONIST_ID_KEY, id);
  }
}
